const UnsplashIcon = /*#__PURE__*/ [
  ["path", { d: "M9.5 7.5V4.5H14.5V7.5H9.5Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M16 16V11H19.5V19.5H4.5V11H8V16H16Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }]
];

export { UnsplashIcon as default };
//# sourceMappingURL=UnsplashIcon.js.map
